<template>
  <div id="plannerAssignLevel" class=" ">
    <div class="admin-wrap" style="margin-top: 10px">
      <K2Row space-between="true">
        <div class="text-left">
          <h4 class="text-left">{{ selectedAcademicYear }} {{ lang('Learning Goals') }}</h4>
        </div>
        <K2Row id="button-area" class="col-lg-24 text-right actionDiv">
          <!--<K2Button size="small" type="primary" :hideRound="true" @onclick="saveLevel()" class="me-2"-->
          <!--:background="uiVariable.color.button1">-->
          <!--{{lang("Save")}}-->
          <!--</K2Button>-->
          <K2Button size="small" type="primary" :hideRound="true" @onclick="() => $router.push('/PlannerLevel')">
            {{ lang('Back') }}
          </K2Button>
        </K2Row>
      </K2Row>
      <!--<K2Tab class="mt-3" :tabList="tabList" @onclick="handleTabs"/>-->
      <div class="mt-3 px-2 domainSelect">
        <div class="p-1 px-3 plannerSelectGoals rounded">
          <K2Select @onChange="handleSelectGoals" class="me-3" label="Select Learning Domain" :select-list="ddlGoalsListDomain" />
        </div>
        <div class="text-left mt-3">
          <div v-for="(item, index) of selectedDomain.ArrObj_Items" class="mb-3 pb-2">
            <b-card no-body class="mb-2 border-0 border-bottom">
              <b-card-header header-tag="header" class="p-1 box purple border-0" role="tab">
                <K2Row align="center" class="p-2" v-b-toggle="'my-collapse' + index">
                  <K2Icon color="black" name="add" class="when-closed me-2" :font-size="uiVariable.fontSize.md" style="line-height: 16px" />
                  <K2Icon color="black" name="remove" class="when-open me-2" :font-size="uiVariable.fontSize.md" style="line-height: 16px" />
                  <a> Learning Goal {{ item.goalOrder }} : {{ item.CombineGoals }}</a>
                </K2Row>
                <!--<div class="plannerGoals mb-4" v-if="item.CombineGoals">-->
                <!--&lt;!&ndash;<K2Text class="plannerLabel mb-2">Goals</K2Text>&ndash;&gt;-->
                <!--<K2Text class=" ">Learning Goal {{item.goalOrder}} : {{ item.CombineGoals }}</K2Text>-->
                <!--</div>-->
              </b-card-header>
              <b-collapse v-bind:id="'my-collapse' + index" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <div class="plannerIndicator">
                    <K2Row>
                      <div class="indicator">
                        <K2Text class="plannerLabel mb-2">Knowledge, Skills and Dispositions (KSDs)</K2Text>
                      </div>
                      <!--<div class="indicator">-->
                      <!--<K2Text class="plannerLabel mb-2">Hints</K2Text>-->
                      <!--</div>-->
                      <template v-if="isPNN1">
                        <K2Text class="indicatorLabel">PNS1</K2Text>
                        <K2Text class="indicatorLabel">PNS2</K2Text>
                        <K2Text class="indicatorLabel">N1S1</K2Text>
                        <K2Text class="indicatorLabel">N1S2</K2Text>
                      </template>
                      <template v-else>
                        <K2Text class="indicatorLabel">Term 1</K2Text>
                        <K2Text class="indicatorLabel">Term 2</K2Text>
                        <K2Text class="indicatorLabel">Term 3</K2Text>
                        <K2Text class="indicatorLabel">Term 4</K2Text>
                      </template>
                    </K2Row>
                    <K2Row v-for="(indicator, i) of item.ArrObj_Items" :key="i" class="border-bottom mb-3">
                      <div class="indicator">
                        <K2Text class="indicator">
                          {{ indicator && indicator[0].PlnMasOrder }}
                          {{ indicator && indicator[0].combineIndicator }}
                        </K2Text>
                        <!--<br/>-->
                        <!--<K2Text class="indicator hints"> Possible Evidence/Indication:-->
                        <!--{{ indicator.PlnMasGoalsITL }}-->
                        <!--</K2Text>-->
                      </div>
                      <el-checkbox
                        :value="indicator.term1"
                        class="indicatorLabel"
                        :disabled="true"
                        :id="isPNN1 && !indicator[0].PlnMasLevels.includes('PNS1') ? 'invalid' : ''"
                        @change="() => onIndicatorCheck(indicator, 'term1')"
                      ></el-checkbox>
                      <el-checkbox
                        :value="indicator.term2"
                        class="indicatorLabel"
                        :disabled="true"
                        :id="isPNN1 && !indicator[0].PlnMasLevels.includes('PNS2') ? 'invalid' : ''"
                        @change="() => onIndicatorCheck(indicator, 'term2')"
                      ></el-checkbox>
                      <el-checkbox
                        :value="indicator.term3"
                        class="indicatorLabel"
                        :disabled="true"
                        :id="isPNN1 && !indicator[0].PlnMasLevels.includes('N1S1') ? 'invalid' : ''"
                        @change="() => onIndicatorCheck(indicator, 'term3')"
                      ></el-checkbox>
                      <el-checkbox
                        :value="indicator.term4"
                        class="indicatorLabel"
                        :disabled="true"
                        :id="isPNN1 && !indicator[0].PlnMasLevels.includes('N1S2') ? 'invalid' : ''"
                        @change="() => onIndicatorCheck(indicator, 'term4')"
                      ></el-checkbox>
                    </K2Row>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
      <!--      <div v-if="selectedTab==='2'" class="px-2 domainSelect">-->
      <!--        <K2Row justify_content="flex-end">-->
      <!--          <K2Button size="small" type="primary" :hideRound="true" @onclick="AddCustomGoals()" class="me-2"-->
      <!--                    :background="uiVariable.color.button1">-->
      <!--            {{ lang("Add Custom Goals") }}-->
      <!--          </K2Button>-->
      <!--        </K2Row>-->
      <!--        <PlannerCustomGoals :ddlCustomGoalList="ddlCustomGoalList"-->
      <!--                            @changeSelectionCus="changeSelectionCus"-->
      <!--                            :ddlCustomGoalDomainList="ddlCustomGoalDomainList"-->
      <!--                            :ddlTermCusGoalsList="ddlTermCusGoalsList"/>-->
      <!--      </div>-->
    </div>
    <!--    <K2Modal :dialog="modal==='assignedPlannerShowModel'" @handleClose="handleClose"-->
    <!--             @onConfirm="handleClose"-->
    <!--             :hideFooter="true">-->
    <!--      <AssignCustomPlanner :ddlGoalsListDomain="ddlGoalsListDomain" :ddlGoalsList="ddlGoalsList"-->
    <!--                           @assignCustomGoal="assignCustomGoal"/>-->
    <!--    </K2Modal>-->
  </div>
</template>

<script>
import { lang } from '../../locale/index'
import DataSource from '../../data/datasource'
import { selectedLocale } from '../../locale'
import Cookies from 'js-cookie'
import K2Row from '../../uiComponents/k2Row/k2Row'
import K2Text from '../../uiComponents/k2Text/k2Text'
import K2Button from '../../uiComponents/k2Button/k2Button'
import uiVariable from '../../config/uiVariable'
import K2Tab from '../../uiComponents/k2Tab/k2Tab'
import K2Dropdown from '../../uiComponents/k2Dropdown/k2Dropdown'
import K2Select from '../../uiComponents/k2Select/k2Select'
import './planner.scss'
import PlannerCustomGoals from './component/plannerCustomGoals'
import K2Modal from '../../uiComponents/k2Modal/k2Modal'
import AssignCustomPlanner from './component/assignCustomPlanner'
import K2Icon from '../../uiComponents/k2Icon/k2MAIcon'

export default {
  name: 'PlannerLevelAssign',
  components: { K2Icon, AssignCustomPlanner, K2Modal, PlannerCustomGoals, K2Select, K2Tab, K2Button, K2Text, K2Row },
  data() {
    return {
      uiVariable: uiVariable,
      ddlGoalsList: [],
      ddlGoalsListDomain: [],
      ddlSemesterDetailsList: [],
      TermSemdID: [],
      ddlTermGoalsLists: [],
      ddlTermCusGoalsList: [],
      schID: '',
      crsID: '',
      level: '',
      semID: '',
      modal: null,
      selectedAcademicYear: '',
      selectedTab: '1',
      tabList: [
        {
          label: lang('Level Goals'),
          key: '1',
        },
        {
          label: lang('Other Goals'),
          key: '2',
        },
      ],
      selectedDomain: '',
      ddlCustomGoalList: [],
      ddlCustomGoalDomainList: [],
      GoalDomainSelectionList: [],
      plannerMaster: [],
      isPNN1: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    lang,
    // handleTabs(val) {
    //   this.selectedTab = val;
    // },
    handleClose() {
      this.modal = null
    },

    async init() {
      // await this.getPlannerMaster2();

      if (this.$route.params.data) {
        this.$vs.loading()
        let params = this.$route.params.data
        this.crsID = params.PK_Course_ID
        this.level = params.CRS_Level
        this.semID = params.ClS_FK_Semester_ID
        this.selectedAcademicYear = params.CRS_Course_Name
        this.isPNN1 = params.CRS_Course_Name.includes('Pre-Nursery') || params.CRS_Course_Name.includes('Nursery 1')
        this.ddlGoalsList = await this.groupGoalsList(params.CRS_Level)
        // await this.bindSemesterDetails();
        this.ddlGoalsList?.forEach(n => {
          const pos = this.ddlGoalsListDomain.indexOf(n.PlnMasDomain)
          if (pos === -1 && n.PlnMasDomain) {
            this.ddlGoalsListDomain.push(n.PlnMasDomain)
          }
        })
        // let ddlTermGoalsLists = [];
        // let ddlTermCusGoalsList = [];
        //
        // for (let d of this.TermSemdID) {
        //   const goals = await this.getLevelGoals(d);
        //   const cusGoals = await this.getLevelCustomGoals(d);
        //   ddlTermGoalsLists.push(goals);
        //   ddlTermCusGoalsList.push(cusGoals);
        // }
        // this.ddlTermGoalsLists = ddlTermGoalsLists;
        // this.ddlTermCusGoalsList = ddlTermCusGoalsList;
        // this.ddlCustomGoalList = await this.getSaveCustomGoalList();
        // this.generateCustomDomainList(this.ddlCustomGoalList);
        this.goalRefresh++
        this.$vs.loading.close()
        this.$forceUpdate()
      }
    },
    async getPlannerMaster2() {
      const response = await DataSource.shared.getPlannerMaster2(this.$route.params.data?.CRS_Level)
      if (response) {
        this.plannerMaster = response
      }
    },
    handleSelectGoals(selected) {
      let selectedDomain = this.ddlGoalsList.find(d => d.PlnMasDomain === selected)

      // selectedDomain?.ArrObj_Items?.forEach(d => {
      //   d?.ArrObj_Items?.map(a => {
      //     a.term1 = false;
      //     a.term2 = false;
      //     a.term3 = false;
      //     a.term4 = false;
      //   });
      // });
      this.selectedDomain = selectedDomain
    },
    onIndicatorCheck(indicator, type) {
      indicator[type] = !indicator[type]
      this.$forceUpdate()
    },
    async groupGoalsList(LevelType) {
      let levelList = []
      levelList.push(LevelType)
      this.results = await this.getNewPlannerMaster(this.isPNN1 ? ['PNS1', 'N1S1'] : levelList)

      if (this.results) {
        let newGoalsList = []
        let tempCombineGoals
        let crsLevel = this.$route.params.data?.CRS_Level

        let newResult = this.separateGoalByLang()
        newResult.forEach(m => {
          m.term1 = false
          m.term2 = false
          m.term3 = false
          m.term4 = false

          let assignedList = m?.[0]?.PlnMasLevels?.split(',')
          assignedList?.forEach(f => {
            switch (f) {
              case 'PNS1':
              case crsLevel + 'T1':
                m.term1 = true
                break
              case 'PNS2':
              case crsLevel + 'T2':
                m.term2 = true
                break
              case 'N1S1':
              case crsLevel + 'T3':
                m.term3 = true
                break
              case 'N1S2':
              case crsLevel + 'T4':
                m.term4 = true
                break
            }
          })

          if (m?.[0]?.PlnMasDomain?.trim() === 'The Child as a Communicator' || m?.[0]?.PlnMasDomain?.trim() === '善交流的儿童') {
            m.PlnMasDomain = `The Child as a Communicator 善交流的儿童`
            tempCombineGoals = m?.length < 2 ? `${m?.[0]?.PlnMasGoals}` : `${m?.[0]?.PlnMasGoals} ${m?.[1]?.PlnMasGoals}`
          } else {
            let enLabel = m?.find(goal => goal?.PlnMasLang === 'EN')
            let cnLabel = m?.find(goal => goal?.PlnMasLang === 'CH' || goal?.PlnMasLang === 'CN')
            m.PlnMasDomain = `${enLabel?.PlnMasDomain?.trim()} ${cnLabel?.PlnMasDomain?.trim()}`
            tempCombineGoals = `${m?.[0]?.PlnMasGoals} ${m?.[1]?.PlnMasGoals}`
          }

          m.forEach(d => {
            if (d?.PlnMasOrder !== '') {
              let split = d?.PlnMasOrder.split('.')
              d.goalOrder = `${split[0]}.${split[1]}`
            }
            d.combineIndicator = m?.[1] ? `${m?.[0]?.PlnMasIndicator} ${m?.[1]?.PlnMasIndicator}` : `${m?.[0]?.PlnMasIndicator}`
          })
          const exist = newGoalsList?.find(d => d.PlnMasDomain?.trim().includes(m.PlnMasDomain?.trim()))
          if (!exist) {
            const newGoal = {
              PlnMasDomain: m.PlnMasDomain?.trim(),
              ArrObj_Items: [],
            }

            const goalExist = newGoal.ArrObj_Items.find(d => d.CombineGoals?.trim() === tempCombineGoals?.trim())
            if (goalExist) {
              goalExist.ArrObj_Items.push(m)
            } else {
              const newGoalItem = {
                CombineGoals: tempCombineGoals,
                goalOrder: m?.[0]?.goalOrder,
                ArrObj_Items: [m],
              }
              newGoal.ArrObj_Items.push(newGoalItem)
            }
            newGoalsList.push(newGoal)
          } else {
            const goalExist = exist.ArrObj_Items.find(d => d.CombineGoals?.trim() === tempCombineGoals?.trim())
            if (goalExist) {
              goalExist.ArrObj_Items.push(m)
            } else {
              const newGoalItem = {
                CombineGoals: tempCombineGoals,
                goalOrder: m?.[0]?.goalOrder && m?.[0]?.goalOrder,
                ArrObj_Items: [m],
              }
              exist.ArrObj_Items.push(newGoalItem)
            }
          }
        })

        return newGoalsList
      }
    },
    separateGoalByLang() {
      let newResult = []
      if (this.isPNN1) {
        this.results?.forEach(d => {
          if (d?.[0]?.PlnMasDomain === 'The Child as a Communicator' || d?.[0]?.PlnMasDomain === '善交流的儿童') {
            if (d?.[0]?.PlnMasOrder?.includes('2.1.') || d?.[0]?.PlnMasOrder?.includes('2.2.')) {
              newResult?.push([d?.[0]])
              if (d?.length > 1) {
                newResult?.push([d?.[1]])
              }
            } else {
              newResult?.push(d)
            }
          } else {
            newResult?.push(d)
          }
        })

        return newResult
      } else {
        return this.results
      }
    },
    async getNewPlannerMaster(LevelType) {
      try {
        // let filterLevel = this.isPNN1 ? (LevelType+"S1") : LevelType;
        const response = await DataSource.shared.getPlannerMaster2(JSON.stringify(LevelType))
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getPlannerMaster error')
          } else if (response.code === '2') {
            console.log('getPlannerMaster no record')
          } else {
            return response
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getPlannerMaster(LevelType) {
      try {
        let result = []
        let IB = 'NON IB'

        if (Cookies.get('schoolSession') === ('SCH201400000553' || 'SCH201400000471')) {
          if (LevelType === ('N2' || 'K1' || 'K2')) {
            IB = 'IB'
          } else if (selectedLocale() === 'CH') {
            IB = 'IB'
          }
        }

        const response = await DataSource.shared.getPlannerMaster(LevelType, '', '', '', IB)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getPlannerMaster error')
          } else if (response.code === '2') {
            console.log('getPlannerMaster no record')
          } else {
            result = response.Table
          }
        }
        return result
      } catch (e) {
        this.results = e
      }
    },
    // async bindSemesterDetails() {
    //   try {
    //
    //     this.ddlSemesterDetailsList = [];
    //     let result = [];
    //
    //     const response = await DataSource.shared.getSemesterTermDetailsBySemID(this.semID, "", "Active");
    //     if (response) {
    //       result = response.Table;
    //       result.forEach(m => {
    //         this.ddlSemesterDetailsList.push(m);
    //       });
    //     }
    //   } catch (e) {
    //     this.results = e;
    //   }
    //   let tempTermSemdID = [];
    //   let filterList = this.ddlSemesterDetailsList.filter(d => d.SEMD_DetailName === "Term 1" || "Term 2" || "Term 3" || "Term 4");
    //   if (filterList) {
    //     filterList.forEach(d => {
    //       tempTermSemdID.push(d.PK_SEMD_ID);
    //     });
    //   }
    //   this.TermSemdID = tempTermSemdID;
    // },
    // async getLevelGoals(semID) {
    //   try {
    //     let result = [];
    //
    //     const response = await DataSource.shared.getPlannerAssignedToLevel(this.crsID, semID);
    //     if (response) {
    //       if (response.code === "2") {
    //         console.log("getPlannerAssignedStudentDetails no record");
    //       } else if (response.code === "88") {
    //         window.location.replace("/");
    //       } else if (response.code === "99") {
    //         console.log("getPlannerAssignedStudentDetails error");
    //       } else {
    //         response.Table.forEach(m => {
    //           let temp = m.PlnCxPlnMasID;
    //           result.push(temp);
    //         });
    //       }
    //     }
    //     return result;
    //   } catch (e) {
    //     this.results = e;
    //   }
    // },
    // async getSaveCustomGoalList() {
    //   try {
    //     const response = await DataSource.shared.getSaveCustomGoalList(
    //         JSON.stringify(this.ddlTermCusGoalsList[0]),
    //         JSON.stringify(this.ddlTermCusGoalsList[1]),
    //         JSON.stringify(this.ddlTermCusGoalsList[2]),
    //         JSON.stringify(this.ddlTermCusGoalsList[3])
    //     );
    //     let result = [];
    //     result = response.Table;
    //     return result;
    //   } catch (e) {
    //     return [];
    //   }
    // },
    // generateCustomDomainList(goalList) {
    //   if (goalList) {
    //     goalList.forEach(goal => {
    //       if (this.ddlCustomGoalDomainList.indexOf(goal.PlnCusDomain) < 0) {
    //         this.ddlCustomGoalDomainList.push(goal.PlnCusDomain);
    //       }
    //     });
    //   }
    // },
    // async getLevelCustomGoals(semID) {
    //   try {
    //     let result = [];
    //
    //     const response = await DataSource.shared.getCustomPlannerAssignedToLevel(this.crsID, semID);
    //     if (response) {
    //       if (response.code === "2") {
    //         console.log("getPlannerAssignedStudentDetails no record");
    //       } else if (response.code === "88") {
    //         window.location.replace("/");
    //       } else if (response.code === "99") {
    //         console.log("getPlannerAssignedStudentDetails error");
    //       } else {
    //         response.Table.forEach(m => {
    //           let temp = m.PlnCuxPlnCusID;
    //           result.push(temp);
    //         });
    //       }
    //     }
    //     return result;
    //   } catch (e) {
    //     this.results = e;
    //   }
    //
    // },

    // async saveLevel() {
    //   let newPlannerAssignedToSchoolObjJson = {
    //     CrsID: this.crsID,
    //     semID: this.semID,
    //     Term1SemdID: this.TermSemdID[0],
    //     Term2SemdID: this.TermSemdID[1],
    //     Term3SemdID: this.TermSemdID[2],
    //     Term4SemdID: this.TermSemdID[3],
    //     Term1GoalsList: this.ddlTermGoalsLists[0],
    //     Term2GoalsList: this.ddlTermGoalsLists[1],
    //     Term3GoalsList: this.ddlTermGoalsLists[2],
    //     Term4GoalsList: this.ddlTermGoalsLists[3]
    //
    //   };
    //   const response = await DataSource.shared.savePlannerAssignedToCourse(JSON.stringify(newPlannerAssignedToSchoolObjJson));
    //   await this.saveCusLevel();
    //   if (response.code === "2") {
    //     this.$notify.error({
    //       title: "Error",
    //       message: "Please select Class & Term..."
    //     });
    //   } else if (response.code === "88") {
    //     window.location.replace("/");
    //   } else if (response.code === "99") {
    //     this.$notify.error({
    //       title: "Error",
    //       message: "Class Goals Details: ERROR!!"
    //     });
    //   } else {
    //     this.$notify.info({
    //       title: "Successfully",
    //       message: "Successfully Save..."
    //     });
    //   }
    //   // console.log(response);
    // },
    // async saveCusLevel() {
    //   let newPlannerAssignedToSchoolObjJson = {
    //     CrsID: this.crsID,
    //     semID: this.semID,
    //     Term1SemdID: this.TermSemdID[0],
    //     Term2SemdID: this.TermSemdID[1],
    //     Term3SemdID: this.TermSemdID[2],
    //     Term4SemdID: this.TermSemdID[3],
    //     Term1GoalsList: this.ddlTermGoalsLists[0],
    //     Term2GoalsList: this.ddlTermGoalsLists[1],
    //     Term3GoalsList: this.ddlTermGoalsLists[2],
    //     Term4GoalsList: this.ddlTermGoalsLists[3]
    //   };
    //
    //   const response = await DataSource.shared.saveCustomPlannerAssignedToCourse(JSON.stringify(newPlannerAssignedToSchoolObjJson));
    //   if (response.code === "2") {
    //     this.$notify.error({
    //       title: "Error",
    //       message: "Please select Class & Term..."
    //     });
    //   } else if (response.code === "88") {
    //     window.location.replace("/");
    //   } else if (response.code === "99") {
    //     this.$notify.error({
    //       title: "Error",
    //       message: "Class Goals Details: ERROR!!"
    //     });
    //   } else {
    //     this.$notify.info({
    //       title: "Successfully",
    //       message: "Successfully Save..."
    //     });
    //   }
    //   // console.log(response);
    // },
    // async AddCustomGoals() {
    //   //??what the code for
    //   const response = await DataSource.shared.getDomainList(this.currentClsID);
    //   this.GoalDomainSelectionList = response.Table;
    //   //??what the code for
    //
    //   this.modal = "assignedPlannerShowModel";
    //   // this.$refs.assignedPlannerShowModel.show();
    // },
    // assignCustomGoal(goal) {
    //   let existInDB = false;
    //   this.ddlCustomGoalList.forEach(m => {
    //     if (m.PlnCusID === goal.PlnCusID) {
    //       existInDB = true;
    //     }
    //
    //   });
    //
    //   if (!existInDB) {
    //     this.ddlCustomGoalList.push(goal);
    //   } else {
    //     this.$notify.error({
    //       title: "Alert",
    //       message: "The goal already exist in the list"
    //     });
    //   }
    //   if (this.ddlCustomGoalDomainList.indexOf(goal.PlnCusDomain) < 0) {
    //     this.ddlCustomGoalDomainList.push(goal.PlnCusDomain);
    //   }
    // },
    // changeSelectionCus(scope, Term) {
    //   let Goal = scope.row.PlnCusID;
    //   let Check = scope.checked;
    //   switch (Term) {
    //     case 1 :
    //       // let cusGoalsList = this.ddlTermCusGoalsList[Term];
    //       // if (Check) {
    //       //   let found = cusGoalsList.find(d => d.PlnCusID === Goal);
    //       //   if (found) {
    //       //     this.ddlTermCusGoalsList[Term].push(Goal);
    //       //   }
    //       // }
    //       if (Check) {
    //         if (this.ddlTermCusGoalsList[Term].indexOf(Goal) === -1) {
    //           this.ddlTerm1CusGoalsList.push(Goal);
    //         }
    //       } else {
    //         this.ddlTerm1CusGoalsList = this.ddlTerm1CusGoalsList.filter(function(goal) {
    //           return goal !== Goal;
    //         });
    //       }
    //       break;
    //     case 2 :
    //       if (Check) {
    //         if (this.ddlTerm2CusGoalsList.indexOf(Goal) === -1) {
    //           this.ddlTerm2CusGoalsList.push(Goal);
    //         }
    //       } else {
    //         this.ddlTerm2CusGoalsList = this.ddlTerm2CusGoalsList.filter(function(goal) {
    //           return goal !== Goal;
    //         });
    //       }
    //       break;
    //     case 3:
    //       if (Check) {
    //         if (this.ddlTerm3CusGoalsList.indexOf(Goal) === -1) {
    //           this.ddlTerm3CusGoalsList.push(Goal);
    //         }
    //       } else {
    //         this.ddlTerm3CusGoalsList = this.ddlTerm3CusGoalsList.filter(function(goal) {
    //           return goal !== Goal;
    //         });
    //       }
    //       break;
    //     case 4 :
    //       if (Check) {
    //         if (this.ddlTerm4CusGoalsList.indexOf(Goal) === -1) {
    //           this.ddlTerm4CusGoalsList.push(Goal);
    //         }
    //       } else {
    //         this.ddlTerm4CusGoalsList = this.ddlTerm4CusGoalsList.filter(function(goal) {
    //           return goal !== Goal;
    //         });
    //       }
    //       break;
    //   }
    // }
  },
}
</script>
